export default "__VITE_ASSET__BYgbUWfJ__"